export default __webpack_public_path__ + "static/media/delivery-3.83282990.png";